/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mj_deep_extend } from './util.js';


class SearchResultInfo {

	_state;

	constructor( state ) {
		const defaults = {
			'list_type':		'search',
			'list_id':			null,
			'list_count':		null,
			'tree_id':			null,
			'cat_id':			null,
			'category_count':	null
		};

		// init result state data
		// -> ensure _state becomes independent object (a deep copy of defaults plus provided state)
		this._state = mj_deep_extend( {}, defaults, state||{} );
	}

	getType() {
		return this._state.list_type;
	}

	getId() {
		return this._state.list_id;
	}

	getState() {
		return this._state;
	}

	createCopy() {
		return new SearchResultInfo(this._state);
	}

}


function createSearchResultInfo( state ) {
	return new SearchResultInfo(state);
}



export {
	SearchResultInfo,
	createSearchResultInfo,
};

